import { VBaseCheckboxRadio } from '../VBaseCheckboxRadio';
import VRadioGroupInnerItem from './VRadioGroupInnerItem';
import type { VRadioGroupItemProps } from './type';

const VRadioGroupItem = ({ size = 'md', ...props }: VRadioGroupItemProps) => {
  return (
    <VBaseCheckboxRadio id={props.id} label={props.label} size={size}>
      <VRadioGroupInnerItem value={props.value} size={size} />
    </VBaseCheckboxRadio>
  );
};

export default VRadioGroupItem;
